import { customTextBlock, paragraph, heading } from "../../../text/nodes"
import { PersonalSignature as PersonalSignatureEditor } from "./personal-signature"
import { PersonalSignatureSettings } from "./personal-signature-settings"
import PersonalSignaturePreview from "./personal-signature-preview.png"

export const PersonalSignature = {
  name: "PersonalSignature",
  label: "email signature with profile image on the left and name on the right",
  EditorComponent: PersonalSignatureEditor,
  SettingsComponent: PersonalSignatureSettings,
  image: PersonalSignaturePreview,
  defaultProperties: {
    backgroundColor: null,
    headingColor: "#000000",
    textColor: "#4d4d4d",
    image: "",
    alt: "",
    horizontalPadding: 0,
    verticalPadding: 0,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    columnRatio: 10,
    borderColor: "#000000",
    borderWidth: 0,
    imageRadius: 50,
    verticalAlign: "top"
  },
  defaultChildren: [
    customTextBlock([heading("three", "Your Name"), paragraph("Creator")])
  ]
}
